import React from "react";
import { SmartApplyTemplate } from "../../../../template/smart-apply/default-template";
import { ProcedureAssignmentSettingRuleSetEntity } from "../../../../../application/domain/procedure-assignment-setting-ruleset/procedure-assignment-setting-ruleset-entity";
import { SmartApplyMenuList } from "../../../../organisms/smart-apply/menu-list";
import {
  InformationBanner,
  Pagination,
  Spinner,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
} from "@graffer-inc/console-design-kit";
import { paging } from "../../../../../application/domain/pagination/paging";
import classnames from "classnames";
import { ProcedureAssignmentSettingRuleSetContentHeader } from "./contentHeader";
import { useHistory } from "react-router-dom";
import { SmartApplyR } from "../../route";

export interface ProcedureAssignmentSettingRuleSetListPresenterProps {
  ruleSets: ProcedureAssignmentSettingRuleSetEntity[];
  isLoading: boolean;
  paging: paging;
  movePage: (page: number) => void;
}

export const ProcedureAssignmentSettingRuleSetListPresenter: React.FC<
  ProcedureAssignmentSettingRuleSetListPresenterProps
> = ({ ruleSets, isLoading, paging, movePage }) => {
  const history = useHistory();

  const handleRowClick = (id: string) => {
    history.push(SmartApplyR.AssignmentSettingRulesetEdit.link({ id }));
  };

  return (
    <SmartApplyTemplate
      breadcrumbs={[{ to: "#", title: "申請振り分け設定一覧" }]}
      menuList={<SmartApplyMenuList />}
      contentsHeader={<ProcedureAssignmentSettingRuleSetContentHeader />}
    >
      <div className="rulesets">
        {ruleSets?.length > 0 && (
          <Table borderType="row" wrapper={false}>
            <TableHeader>
              <TableRow>
                <Th>ID</Th>
                <Th>申請振り分け設定名</Th>
                <Th>説明</Th>
              </TableRow>
            </TableHeader>
            <TableBody>
              {ruleSets.map((r) => (
                <TableRow key={r.id} onClick={() => handleRowClick(r.id)}>
                  <Td>{r.id}</Td>
                  <Td>{r.name}</Td>
                  <Td>{r.description}</Td>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        {!isLoading && ruleSets?.length === 0 && (
          <div className="py-2">
            <InformationBanner
              message="申請振り分け設定がまだ登録されていません。"
              description="「新規登録」より、申請振り分け設定を登録してください。"
            />
          </div>
        )}
        {paging.total > 0 && (
          <div className={classnames("rulesets-pagination-footer")}>
            <Pagination
              onPageClick={movePage}
              currentPage={paging.current}
              lastPage={paging.total}
            />
          </div>
        )}
      </div>
      <Spinner loading={isLoading} />
    </SmartApplyTemplate>
  );
};

export default ProcedureAssignmentSettingRuleSetListPresenter;
